import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  dashboardCards,
  StatisticItem,
  todayStatistics
} from '../data/dashboardData'
import { statisticsV2Service } from '../services'
import { useUIStore } from '../stores/useUIStore'

import { DailyStatisticsResponse } from '@/services/StatisticsV2Service'

// 简单的主页组件
const Dashboard: React.FC = () => {
  const navigate = useNavigate()
  const { showError } = useUIStore()
  const [statistics, setStatistics] = useState<StatisticItem[]>(todayStatistics)
  // const [loading, setLoading] = useState(false)

  const handleCardClick = (route: string, disabled?: boolean) => {
    if (!disabled) {
      navigate(route)
    }
  }

  // 获取统计数据
  const fetchStatistics = async () => {
    try {
      // setLoading(true)
      // const data = await monitorService.getDailyStatistics()
      const {success, data} = await statisticsV2Service.daily()
      if (success && data) {
        // 更新统计数据
        const updatedStats = todayStatistics.map((stat) => ({
          ...stat,
          value: data[stat.key as keyof DailyStatisticsResponse] || '--'
        }))
        setStatistics(updatedStats)
      }

    } catch (error) {
      console.error('获取统计数据失败:', error)
      showError('获取统计数据失败')
    } finally {
      // setLoading(false)
    }
  }

  useEffect(() => {
    fetchStatistics()
  }, [])

  return (
    <div className="h-full overflow-y-auto bg-gray-50">
      {/* 主要内容区域 */}
      <div className="mx-auto space-y-6">
        {/* 快速统计 */}

        <div>
          <h3 className="text-lg font-semibold text-gray-900">数据概览</h3>
          <p className="text-sm text-gray-600 mt-1">实时更新的业务统计数据</p>
          {/* <button
                onClick={fetchStatistics}
                disabled={loading}
                className={`inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  loading
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700 text-white hover:shadow-md'
                }`}
                title="刷新统计数据"
              >
                <RefreshCw className={`w-4 h-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
                刷新
              </button> */}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {statistics.map((stat, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-lg p-4 border border-gray-200 hover:border-gray-300 transition-all duration-200 hover:shadow-sm">
                <div className={`text-2xl font-bold ${stat.color} mb-1`}>
                  {stat.value}
                </div>
                <div className="text-sm text-gray-600 font-medium">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 功能模块 */}
        <div>
          <h2 className="text-lg font-semibold text-gray-900">业务模块</h2>
          <p className="text-sm text-gray-600 mt-1">选择功能模块开始操作</p>
        </div>
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {dashboardCards.map((card) => {
              const IconComponent = card.icon

              return (
                <div
                  key={card.id}
                  onClick={() => handleCardClick(card.route, card.disabled)}
                  className={`bg-white border border-gray-200 hover:border-gray-300 hover:shadow-md transition-all duration-200 rounded-lg p-4 flex flex-col h-full ${
                    card.disabled
                      ? 'cursor-not-allowed opacity-60'
                      : 'cursor-pointer'
                  }`}
                >
                  {/* 头部图标和标题区域 */}
                  <div className="flex items-center mb-4">
                    <div
                      className={`inline-flex items-center justify-center w-12 h-12 rounded-lg ${card.iconBgColor} mr-3`}
                    >
                      <IconComponent className={`w-6 h-6 ${card.iconColor}`} />
                    </div>
                    <div className="flex-1">
                      <h3
                        className={`text-lg font-semibold ${
                          card.disabled ? 'text-gray-500' : 'text-gray-900'
                        }`}
                      >
                        {card.title}
                      </h3>
                      {card.description && (
                        <p
                          className={`text-sm mt-1 ${
                            card.disabled ? 'text-gray-400' : 'text-gray-500'
                          }`}
                        >
                          {card.description}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* 功能特性列表 */}
                  <div className="space-y-2">
                    {card.features.map((feature, index) => (
                      <div key={index} className="flex items-start">
                        <div
                          className={`w-1.5 h-1.5 rounded-full mt-2 mr-2 flex-shrink-0 ${
                            card.disabled ? 'bg-gray-300' : 'bg-blue-400'
                          }`}
                        ></div>
                        <span
                          className={`text-sm ${
                            card.disabled ? 'text-gray-400' : 'text-gray-600'
                          }`}
                        >
                          {feature.replace('• ', '')}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
